import React, { useEffect, useState } from "react";
import { restoreComma, transformComma } from "../../utils/validator/comma";
import Button from "../Button";
import Input from "../Input";
import Modal, { ModalHeader } from "../Modal";
import Radios from "../Radio/Radios";

const SupplyCostCalculator = ({
  open,
  setOpen,
  data,
  itemValues,
  setItemValues,
  idx,
}) => {
  const [isIncludeTax, setIsIncludeTax] = useState("0");
  const [sumCost, setSumCost] = useState(0);
  const [supplyCost, setSupplyCost] = useState(0);
  const [taxAmt, setTax] = useState(0);

  useEffect(() => {
    const qty = Number(data.qty) || 0;
    const unitCost = Number(restoreComma(data.unitCost)) || 0;
    if (isIncludeTax === "0") {
      setSumCost(qty * unitCost);
      setSupplyCost(0);
      setTax(0);
    } else {
      const sum = qty * unitCost;
      const tax = Math.ceil(sum * 0.1);
      setSumCost(sum + tax);
      setSupplyCost(0);
      setTax(0);
    }
  }, [isIncludeTax, data]);

  const cancel = () => {
    setOpen(false);
    setIsIncludeTax("0");
  };

  const calculation = () => {
    if (isIncludeTax === "0") {
      const supplyCost = Math[sumCost > 0 ? "floor" : "ceil"](sumCost / 1.1);
      setSupplyCost(supplyCost);
      setTax(sumCost - supplyCost);
    } else {
      const cost = Number(data.qty) * Number(restoreComma(data.unitCost));
      setSupplyCost(cost);
      setTax(sumCost - cost);
    }
  };

  const handleOnSupply = () => {
    const originValues = [...itemValues];

    let changedItemValues = itemValues[idx];
    changedItemValues = {
      ...changedItemValues,
      supplyCost: transformComma(supplyCost),
      taxAmt: transformComma(taxAmt),
    };

    originValues[idx] = changedItemValues;
    setItemValues(originValues);
    setOpen(false);
    setIsIncludeTax("0");
  };

  return (
    <Modal isOpen={open} close={cancel}>
      <div className="supply-cost-calculator">
        <ModalHeader>공급가액, 세액 자동계산</ModalHeader>
        <Radios
          field={{
            key: "isIncludeTax",
            defaultChecked: isIncludeTax,
            options: {
              list: [
                { label: "부가세 포함", value: "0" },
                { label: "부가세 미포함", value: "1" },
              ],
            },
            onChange: (e) => {
              setIsIncludeTax(e.target.value);
            },
          }}
          className="box-style"
        />
        <div className="sum-calculator-description">
          <p className="description">
            합계금액 입력 후, 공급가액과 세액 계산가능
          </p>
          <p className="description color-red-100">
            1원 정도 차이가 있을 수 있으므로 다시 확인하세요.
          </p>
        </div>
        <div className="sum-calculator">
          <table className="sum-calculator-table">
            <tbody>
              <tr>
                <th className="label-wrap">합계</th>
                <td className="input-wrap" colSpan={3}>
                  <Input className="sum-value-input" value={transformComma(sumCost)}></Input>
                  <Button
                    className="button"
                    size="sm"
                    label="계산하기"
                    color="line"
                    action={calculation}
                  />
                </td>
              </tr>
              <tr>
                <th className="label-wrap">공급가액</th>
                <td className="input-wrap">
                  <Input value={transformComma(supplyCost)}></Input>
                </td>
                <th className="label-wrap">세액</th>
                <td className="input-wrap">
                  <Input value={transformComma(taxAmt)}></Input>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="submit-button-wrap float-right">
          <Button
            className="button"
            size="lg"
            label="취소"
            color="text"
            action={cancel}
          />
          <Button
            className="button"
            size="lg"
            label="적용하기"
            action={handleOnSupply}
          />
        </div>
      </div>
    </Modal>
  );
};

export default SupplyCostCalculator;
